import FeedPostModal from "components/files/modals/FeedPostModal";
import FeedLayout from "layouts/files/FeedLayout";
import { useState } from "react";
import { EngajmentModal, FeedPost, GiFsModal, ThreadPost } from "components";
import FeedPost2 from "components/files/feed/FeedPost2";
import FeedPost3 from "components/files/feed/FeedPost3";
import FeedPost4 from "components/files/feed/FeedPost4";
import FeedPostFixedTriggerer from "ui/files/feed-form/FeedPostFixedTriggerer";
import LightBox from "components/files/feed/LightBox";
import { UserPopover } from "ui";
const ThreadPostPage = () => {
    const [openPostsModal, setOpenPostsModal] = useState(false);
    const [openEngagmentModal, setOpenEngagmentModal] = useState(false);

    return (
        <FeedLayout pageTitle="Timeline">
            <UserPopover />
            <ThreadPost showThreads={true} />
            <FeedPost />
            <FeedPost2 />
            <FeedPost3 />
            <FeedPost4 />
            <FeedPost />
            <LightBox />
            <FeedPostModal
                open={openPostsModal}
                setOpen={setOpenPostsModal}
                setOpenEngajment={setOpenEngagmentModal}
            />
            <GiFsModal />
            <EngajmentModal
                open={openEngagmentModal}
                setOpen={setOpenEngagmentModal}
            />
            <FeedPostFixedTriggerer setOpenPostsModal={setOpenPostsModal} />
        </FeedLayout>
    );
};

export default ThreadPostPage;
